var app = angular.module('directives.inputfield');
  app.directive('inputfield', [
      'configs',
      '$translate',
      '$state',
      function(configs, $translate, $state) {
          return {
            restrict: 'E',
            scope: {
              label: '=',
              value: '=',
              action: '=',
              fnc: '<',
              clear: '<'
            },
            template: require('../templates/field.html'),
            controller: [
              '$scope',
              function($scope) {
                $scope.cardName = $scope.value;
                $scope.clearField = function () {
                  // $scope.cardName = $scope.value;
                  $scope.clear();
                }
              }
            ]
          }
  }]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/inputfield/directives/inputfield.js
 ** module id = 166
 ** module chunks = 1
 **/